import { NgModule } from '@angular/core';

import { ErrorMessageComponent } from './error-message.component';

@NgModule({
    imports: [],
    exports: [ErrorMessageComponent],
    declarations: [ErrorMessageComponent],
    providers: [],
})
export class ErrorMessageModule { }
